import api from "./api";
import {
  WorkoutPlan,
  Tracking,
  User,
  ListStudentsResponse,
  RenewStudentPayload,
} from "../types";

async function listAll(professional_id: string): Promise<ListStudentsResponse> {
  try {
    const { data } = await api.get(
      `/professionals/${professional_id}/students/`,
    );

    if (Array.isArray(data)) {
      return { students: data };
    }
    return { students: [] };
  } catch (e) {
    return {
      students: [],
    };
  }
}

async function renew(payload: RenewStudentPayload) {
  try {
    const { data } = await api.post(`/professionals/renew_validity/`, payload);
    return data;
  } catch (e) {
    return {
      students: [],
    };
  }
}

async function prescription(prescription: WorkoutPlan) {
  try {
    await api.post(`/workout-plans/`, prescription);
    return true;
  } catch (e) {
    return false;
  }
}

async function get_all_prescription(
  professional_id: string,
  user_id: string,
): Promise<WorkoutPlan[]> {
  try {
    const { data } = await api.get(
      `/workout-plans/${professional_id}/${user_id}/`,
    );
    return data;
  } catch (e) {
    return [];
  }
}

async function create(body: Partial<User>) {
  try {
    await api.post(`/users/register/`, body);
    return true;
  } catch (e) {
    return false;
  }
}

async function updateProfile(
  user_id: string | number,
  body: Partial<User>,
): Promise<User | null> {
  try {
    const { data } = await api.put(`/users/${user_id}/profile/`, body);
    return data;
  } catch (e) {
    return null;
  }
}

async function resetPassword(user_id: string | number): Promise<boolean> {
  try {
    await api.post(`/users/${user_id}/reset-password/`);
    return true;
  } catch (e) {
    return false;
  }
}

async function resetPasswordByEmail(email: string): Promise<boolean> {
  try {
    await api.post(`/users/reset-password-by-email/`, { email });
    return true;
  } catch (e) {
    return false;
  }
}

async function list_all_(user_id: string): Promise<Tracking[]> {
  try {
    const { data } = await api.get(`/track/${user_id}/`);
    return data;
  } catch (e) {
    return [];
  }
}

async function importFromSheet({
  file,
  professionalId,
}: {
  file: File;
  professionalId: string;
}) {
  const formData = new FormData();
  formData.append("planilha", file);
  formData.append("professional_id", professionalId);

  const { data } = await api.post(`/professionals/import/`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
}

const students = {
  listAll,
  renew,
  prescription,
  get_all_prescription,
  create,
  list_all_,
  updateProfile,
  resetPassword,
  resetPasswordByEmail,
  importFromSheet,
};

export default students;
